var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.332,23.5H31.667c-1.104,0-2,0.896-2,2v45c0,1.104,0.896,2,2,2h32.665c1.104,0,2-0.896,2-2v-45 C66.332,24.396,65.437,23.5,64.332,23.5z M62.332,68.5H33.667v-41h28.665V68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.201,36.613h19.598c1.104,0,2-0.896,2-2s-0.896-2-2-2H38.201c-1.104,0-2,0.896-2,2S37.097,36.613,38.201,36.613z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.201,45.727h19.598c1.104,0,2-0.896,2-2s-0.896-2-2-2H38.201c-1.104,0-2,0.896-2,2S37.097,45.727,38.201,45.727z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.201,54.84H48c1.104,0,2-0.896,2-2s-0.896-2-2-2h-9.799c-1.104,0-2,0.896-2,2S37.097,54.84,38.201,54.84z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.ad3e3d54357d22fe4ccbe4064b5cbf94.svg";
export { ForwardRef as ReactComponent };